module.exports = __webpack_public_path__ + "static/media/homeEnterprise.bd30cf7d.svg";